import React, { useMemo } from "react";
import ListFiltersSlideOver from "./entity/ListFiltersSlideOver";
import { advancedFilterAppliedToFormValues } from "../shared/utils/advancedFilter";

/**
 * Task list filters: shared panel with Status and Time range enabled.
 * Pass `advancedFields` from the page (same defs used for the Filters tooltip).
 */
export default function TaskListFiltersSlideOver({
  open,
  onClose,
  statusFilter,
  onStatusFilterChange,
  timeNav,
  advancedFields,
  advancedFilterApplied = {},
  onAdvancedFilterFieldChange,
  onClearPanelFilters,
  pageViewPreferenceProps,
}) {
  const fieldList = Array.isArray(advancedFields) ? advancedFields : [];

  const advancedFormValues = useMemo(
    () => advancedFilterAppliedToFormValues(advancedFilterApplied, fieldList),
    [advancedFilterApplied, fieldList]
  );

  return (
    <ListFiltersSlideOver
      open={open}
      onClose={onClose}
      subtitle="Status, criteria, and time range."
      fields={fieldList}
      values={advancedFormValues}
      onFieldChange={onAdvancedFilterFieldChange}
      status={{ value: statusFilter, onChange: onStatusFilterChange }}
      timeRange={timeNav}
      onClear={onClearPanelFilters}
      pageViewPreferenceProps={pageViewPreferenceProps}
    />
  );
}
